import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import {CircularProgress, Typography} from "@mui/material";
import {TextField} from "@variocube/app-ui";
import {debounce} from "lodash";
import React, {useState} from "react";
import {useAsyncCallback} from "react-async-hook";
import {B2Discount} from "../data/client.gen";
import {useSiteApi} from "../data/sites";
import {useLocalization} from "../i18n";
import {isDiscountValid} from "../order-utils";
import {notBlank} from "../utils";

export type DiscountCheckResult = {
	data: B2Discount;
	discountValid: boolean;
};

interface Props {
	tenantId: string;
	siteId: string;
	onDiscountResult: (result: DiscountCheckResult) => void;
}

export function DiscountInput({tenantId, siteId, onDiscountResult}: Props) {
	const {t} = useLocalization();
	const {checkDiscount} = useSiteApi();

	const [code, setCode] = useState("");

	const {result: discount, error: discountError, loading: discountLoading, execute: handleCheckDiscount} =
		useAsyncCallback(checkDiscount);

	const handleDiscountCodeChange = debounce(async (code: string) => {
		setCode(code);
		if (!!code) {
			try {
				const data = await handleCheckDiscount(tenantId, siteId, code);
				onDiscountResult({
					data,
					discountValid: isDiscountValid(data),
				});
			}
			catch (err) {
				console.error(err);
			}
		}
	}, 500);

	return (
		<>
			<TextField
				fullWidth
				variant="standard"
				label={t("discount.discount")}
				onChange={handleDiscountCodeChange}
				sx={{
					mb: "1rem",
				}}
				InputProps={{
					endAdornment: discountLoading
						? <CircularProgress />
						: (discountError !== undefined
							? <ErrorIcon color="error" />
							: (notBlank(code) && <CheckCircleIcon style={{color: "green"}} />)),
				}}
			/>
			{discount !== undefined && (
				<Typography>
					{t("discount.valid")} <strong>-{discount.value}%</strong>
				</Typography>
			)}
		</>
	);
}
